import { openBlock as l, createElementBlock as o, createElementVNode as e } from "vue";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 18"
}, t = /* @__PURE__ */ e("path", {
  fill: "#425466",
  "fill-rule": "evenodd",
  d: "M8.997 16.708a7.708 7.708 0 1 1 0-15.416 7.708 7.708 0 0 1 0 15.416M.04 9a8.958 8.958 0 1 0 17.917 0A8.958 8.958 0 0 0 .039 9",
  "clip-rule": "evenodd"
}, null, -1), d = /* @__PURE__ */ e("path", {
  fill: "#425466",
  "fill-rule": "evenodd",
  d: "m8.575 8.793-.208-.001a.625.625 0 1 1 0-1.25h.029c.17 0 .356 0 .512.02.182.025.416.088.612.285.197.196.26.43.285.613.02.156.02.34.02.511v4.196a.625.625 0 1 1-1.25 0V8.793M8.156 5.667c0-.46.373-.834.834-.834h.007a.833.833 0 0 1 0 1.667H8.99a.833.833 0 0 1-.834-.833",
  "clip-rule": "evenodd"
}, null, -1), c = [
  t,
  d
];
function i(r, a) {
  return l(), o("svg", n, [...c]);
}
const h = { render: i };
export {
  h as default,
  i as render
};
